import { Colors } from "@/enums/Colors";
import { Box, styled } from "@mui/material";
import { ReactNode } from "react";

interface Props {
  children?: ReactNode;
}

const BaseFunderTemplate = (props: Props) => {
  return (
    <Container className="root-container">
      <Container className="card">{props?.children}</Container>
    </Container>
  );
};
export default BaseFunderTemplate;

const Container = styled(Box)(() => ({
  "&.root-container": {
    paddingBlock: "0.875rem",
  },
  "&.card": {
    padding: "12px",
    border: `1px solid ${Colors.LIGHT_GRAY_DEDEE1}`,
    backgroundColor: "white",
    borderRadius: "8px",
    display: "flex",
    flexDirection: "column",
    rowGap: "0.5rem",
  },
  "& .header": {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    columnGap: "0.75rem",
    "& p": {
      fontSize: "0.875rem !important",
    },
  },
  "& .footer": {
    display: "flex",
    flexDirection: "row",
    columnGap: "1.75rem",
  },
  "& .grey-text": {
    color: Colors.LIGHT_GRAY_8A8E93,
  },
  "&  p": {
    fontSize: "0.75rem",
  },
}));
